import * as React from 'react';

const SuccessIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    fill="none"
    viewBox="0 0 50 50"
  >
    <path
      stroke="#1FDF2C"
      strokeLinecap="round"
      strokeWidth="3.028"
      d="M43.033 28.5c0 9.406-7.625 17.031-17.03 17.031S8.972 37.906 8.972 28.501c0-9.407 7.625-17.032 17.03-17.032S43.034 19.094 43.034 28.5Z"
    ></path>
    <path
      stroke="#1FDF2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.25"
      d="m18.5 29.5 5.569 5.569 11.933-11.933"
    ></path>
  </svg>
);

export default SuccessIcon;
